// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_DETAIL_ADDED_TO_PROFILE = "Ko\u010d\u00edk ti pribudol <0>na profile</0>.";
export const STROLLER_DETAIL_REMOVED_FROM_PROFILE = "Ko\u010d\u00edk bol odstr\u00e1nen\u00fd <0>z profilu</0>.";
